import { Link } from 'react-router-dom'
import { Store } from 'lucide-react'
import '../public.css'

// The pages people see before signing in: the landing page and the
// sign-in, sign-up and password pages share this header and footer.

export function Brand() {
  return (
    <Link to="/" className="pub-brand">
      <span className="pub-brand-mark" aria-hidden="true"><Store size={17} /></span>
      <span>ASYS Retail</span>
    </Link>
  )
}

export function PublicHeader({ children }) {
  return (
    <header className="pub-header">
      <div className="pub-wrap pub-header-row">
        <Brand />
        {children && <nav className="pub-header-nav" aria-label="Account">{children}</nav>}
      </div>
    </header>
  )
}

export function PublicFooter({ children }) {
  return (
    <footer className="pub-footer">
      <div className="pub-wrap pub-footer-row">
        <span>© {new Date().getFullYear()} ASYS Retail</span>
        {children && <nav className="pub-footer-nav" aria-label="Footer">{children}</nav>}
      </div>
    </footer>
  )
}

/** One centred card for signing in, signing up and passwords. */
export default function AuthPage({ title, intro, top, children, foot }) {
  return (
    <div className="pub">
      <PublicHeader>{top}</PublicHeader>
      <main className="pub-auth-main">
        <div className="pub-card">
          <h1>{title}</h1>
          {intro && <p className="pub-intro">{intro}</p>}
          {children}
          {foot && <div className="pub-card-foot">{foot}</div>}
        </div>
      </main>
      <PublicFooter />
    </div>
  )
}

/** A labelled input with an optional hint and error, for the auth forms. */
export function AuthField({ id, label, hint, error, children }) {
  return (
    <div className="pub-field">
      <label htmlFor={id}>{label}</label>
      {children}
      {error ? <span className="pub-field-error" role="alert">{error}</span> : hint && <span className="pub-field-hint">{hint}</span>}
    </div>
  )
}
